import { createRouter, createWebHistory } from 'vue-router'

// Lazy-loaded components for code splitting
const Splash = () => import('@/components/Splash')
const NotFound = () => import('@/components/NotFound')
const Callback = () => import('@/components/Callback')
const SelectPartner = () => import('@/components/SelectPartner')
const Product = () => import('@/components/Pages/Product')
const Search = () => import('@/components/Pages/Search')
const Settings = () => import('@/components/Pages/Settings')
const Report = () => import('@/components/Pages/Report')

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', component: Splash, name: "Default" },
        { path: '/search', component: Search, name: "Search" },
        { path: '/settings', component: Settings, name: "Settings" },
        { path: '/product', component: Product, name: "Product" },
        { path: '/callback', component: Callback, name: "Callback" },
        { path: '/selectpartner', component: SelectPartner, name: 'SelectPartner' },
        { path: '/error', component: NotFound, props: true, name: "Error" },
        { path: '/report', component: Report, name: "Report" },
        { path: '/:pathMatch(.*)*', props: true, redirect: '/error' },
    ]
});

export default router